import { KalepIcon } from '@bolteu/kalep-react-icons';

const sizes: Partial<Record<NonNullable<KalepIcon['size']>, number>> = {
  xs: 16,
  sm: 20,
  md: 20,
  lg: 24,
};
export function SuccessIcon(props: KalepIcon) {
  return (
    <svg
      width={sizes[props.size || 'lg']}
      height={sizes[props.size || 'lg']}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12" cy="12" r="12" fill="var(--color-bg-positive-primary)" />
      <path
        d="M10.1565 12.9884L14.4502 8.50496L14.514 8.48835C14.8146 8.17567 15.2223 8 15.6473 8C16.0724 8 16.48 8.17567 16.7806 8.48835C17.0811 8.80104 17.25 9.22514 17.25 9.66734C17.25 10.1096 17.0811 10.5336 16.7806 10.8463L11.2898 16.5088C11.1414 16.6645 10.9649 16.788 10.7704 16.8723C10.5759 16.9566 10.3672 17 10.1565 17C9.94583 17 9.7372 16.9566 9.54269 16.8723C9.34819 16.788 9.17165 16.6645 9.02327 16.5088L6.46942 13.8519C6.16885 13.5392 6 13.1151 6 12.6729C6 12.2307 6.16885 11.8066 6.46942 11.4939C6.76998 11.1813 7.17763 11.0056 7.60269 11.0056C8.02775 11.0056 8.4354 11.1813 8.73596 11.4939L10.1565 12.9884Z"
        fill="white"
      />
    </svg>
  );
}
